import { PropsWithChildren } from "react"

export const SiteCheck = ({ children, country }: PropsWithChildren<{ country: string | string[] }>) => {
    const currentCountry = process.env.NEXT_PUBLIC_COUNTRY
    if (!currentCountry) return null
    if (Array.isArray(country)) {
        return <>{country.includes(currentCountry) ? children : null}</>
    }
    return <>{country === currentCountry ? children : null}</>
}

export const SiteDisable = ({ children, country }: PropsWithChildren<{ country: string | string[] }>) => {
    const currentCountry = process.env.NEXT_PUBLIC_COUNTRY
    if (!currentCountry) return <>{children}</>
    if (Array.isArray(country)) {
        return <>{country.includes(currentCountry) ? null : children}</>
    }
    return <>{country === currentCountry ? null : children}</>
}
